import { render } from "./ReCaptchaInvisible.vue?vue&type=template&id=f8825e82&scoped=true&ts=true"
import script from "./ReCaptchaInvisible.vue?vue&type=script&lang=ts"
export * from "./ReCaptchaInvisible.vue?vue&type=script&lang=ts"

import "./ReCaptchaInvisible.vue?vue&type=style&index=0&id=f8825e82&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Unifi.Web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8825e82"]])

export default __exports__